import {Page} from "./models/Page";
import React from "react";
import {Paginator} from "./models/Paginator";

const PageRow = (page:Page) => {
    page = Object.assign(new Page(), page);
    return <div className="row justify-content-sm-center align-items-center my-1">
        <div className="col-sm-3">
            <a href={page.url()}>
                <img className="page-small rounded loading" src={page.imageUrl("small")}/>
            </a>
        </div>
        <div className="col-sm-4">
            <a href={page.url()}>{page.title}</a>
        </div>
        <div className="col-sm-5 mb-3">
            { `$${page.price || 0.0}` }
        </div>
    </div>
}

const PageList = (paginator:Paginator<Page>, title:string, moreAction:((() => void) | null)=null, moreDisabled=false) => {
    return <>
        <div className="row mt-5 mb-3">
            <h1>{title}</h1>
        </div>
        { paginator.records.map((page:Page) => {
            return PageRow(page);
        })}
        { paginator.hasErrors() && <>
            <div className="row my-2">
                <div className="md-12 text-center alert alert-danger">
                    {paginator.errors().map((error) => {
                        return <>{error}<br/></>
                    })}
                </div>
            </div>
        </>}
        { moreAction && paginator.hasMoreRecords() &&
            <>
                <button className="btn btn-primary" type="button" onClick={() => {
                    moreAction()
                }} disabled={moreDisabled}>
                    + More
                </button>
            </>
        }
    </>
}
export default PageList;
